export interface ShouldAutoSelectCardArgs {
  paymentMethods: { id: string; last4?: string }[];
  filteredOffers?: { id: string }[];
  credits?: { amount?: { amount?: number } };
  selectedPaymentMethodId?: string;
  experimentOn: boolean;
  walletLoaded: boolean;
}

export const shouldAutoSelectCard = (
  args: ShouldAutoSelectCardArgs
): string | undefined => {
  if (!args.experimentOn) return undefined;
  if (!args.walletLoaded) return undefined;
  if (args.selectedPaymentMethodId) return undefined;
  if (args.paymentMethods.length === 0) return undefined;
  if ((args.filteredOffers?.length ?? 0) > 0) return undefined;
  if (args.credits?.amount?.amount) return undefined;
  return args.paymentMethods[0].id;
};
